import { Injectable, TemplateRef } from '@angular/core';
import { SolMenuGroup } from '../components/popover/sol-popover-menu-content/sol-popover-menu-content.state';
import { AbstractService } from './abstract-service';

export interface TopbarServiceState {
  menu: SolMenuGroup[];
  toolbarTemplate: TemplateRef<void> | undefined;
  breadcrumbsTemplate: TemplateRef<void> | undefined;
}

export interface TopbarSubscription {
  unsubscribe: () => void;
}

export interface SolTopbarOptions {
  /**
   * The page's whole action menu. The topbar partitions it on `priority`: promoted items become
   * buttons, the rest stay in the kebab. Grouping drives the separators inside the kebab.
   */
  menu: SolMenuGroup[];
  callback: (actionId: string) => void;
}

@Injectable({
  providedIn: 'root',
})
export class TopbarService extends AbstractService<TopbarServiceState> {
  private callback: (actionId: string) => void = () => {};

  constructor() {
    super({
      menu: [],
      toolbarTemplate: undefined,
      breadcrumbsTemplate: undefined,
    });
  }

  public configure(options: Partial<SolTopbarOptions>): TopbarSubscription {
    this.patch({ menu: options?.menu || [] });
    this.callback = options?.callback || (() => {});
    return {
      unsubscribe: () => {
        this.reset();
      },
    };
  }

  private reset(): void {
    this.patch({ menu: [] });
    this.callback = () => {};
  }

  public onAction(actionId: string): void {
    this.callback(actionId);
  }

  public setToolbar(template: TemplateRef<void> | undefined): void {
    this.patch({ toolbarTemplate: template });
  }

  public setBreadcrumbs(template: TemplateRef<void> | undefined): void {
    this.patch({ breadcrumbsTemplate: template });
  }
}
